module.exports = __webpack_public_path__ + "img/sr2.18b66c6f.png";